module.exports = "https://99designs-start-assets.imgix.net/js/98d574ff09fce7367b3be9a8c37d686d.png";